export type QueueOrganizationRule = {
  called: number;
  approaching: number;
};

export const QUEUE_ORGANIZATION_RULES: Record<number, QueueOrganizationRule> = {
  1: {
    called: 40,
    approaching: 60,
  },
  2: {
    called: 25,
    approaching: 50,
  },
  3: {
    called: 8,
    approaching: 17,
  },
};

export function getQueueOrganizationRule(orgFila?: number | null) {
  return QUEUE_ORGANIZATION_RULES[orgFila || 1] ?? QUEUE_ORGANIZATION_RULES[1];
}

export function getQueueSignalRanges(orgFila?: number | null) {
  const rule = getQueueOrganizationRule(orgFila);

  return [
    {
      label: "Verde",
      range: `1 até ${rule.called}`,
      description: "Chamar agora",
    },
    {
      label: "Azul",
      range: `${rule.called + 1} até ${rule.approaching}`,
      description: "Próximos da vez",
    },
    {
      label: "Amarelo",
      range: `${rule.approaching + 1}+`,
      description: "Aguardando",
    },
  ];
}
